<div class="embed-container" [innerHtml]="conteudoIframe">
  
</div>
<div class="my-2" style="text-align: center;" *ngIf="!concluido ">
    <button class="btn btn-primary btn-sm" (click)="concluirConteudo()" title="Informar a conclusão do conteudo.">Realizado</button>
</div>